//write a function to connect to rest api with axio in post method called UserLogin
import axios from 'axios';
import config from '../config';

const UserLogin = async (username, password) => {
    try {

        const FormData = require('form-data');
        let data = new FormData();
        data.append('mobile', username);
        data.append('password', password);

        const loginData = {
            mobile: username,
            password: password
        };

        const response = await axios.post(config.apiUrl + 'user/login', loginData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Required for sending form data
            },
        });

        if (response.status === 200) {
            localStorage.setItem("oojwt", response.data.token);            
            const role = response.data?.user?.role;
            return {
                status: 200,
                message: response.data.message,
                role: role,
                user: response.data.user
            };                      
        }        
        else {
            return {
                status: 401,
                message: response.data.message
            };
        }        
    } catch (error) {
        console.error(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

//create a function to hit rest api as post with axios with jwt from localstorage in the header
const LoggedUserDetail = async () => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'user/get-by-user-jwt?token=' + token, {}, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                user: response.data.user
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}user/all?page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                users: response.data.users,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

const GetById = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'user/get-by-id?id=' + id,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                user: response.data.user
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

//add user with name, mobile, email, password, image, dob, genderId, cityId, bloodGroupId
const Add = async (name, mobile, email, password, image, dob, genderId, cityId, bloodGroupId, sponsorMobile) => {
    try {
        const FormData = require('form-data');
        let data = new FormData();
        data.append('name', name);
        data.append('mobile', mobile);
        data.append('email', email);
        data.append('password', password);
        data.append('image', image);
        data.append('dob', dob);
        data.append('genderId', genderId);
        data.append('cityId', cityId);
        data.append('bloodGroupId', bloodGroupId);
        data.append('sponsorMobile', sponsorMobile);
        console.log("sponsorMobile in service : " + sponsorMobile);

        console.log("Image in service : " + image);
        console.log("Data in service : " + data);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'user/add', data,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log(response);
        if (response.status === 201) {
            console.log("User added successfully");
            return {
                status: 200,
                message: response.data.message,
                user: response.data.user
            };
        }
        else {
            return {
                status: 400,
                message: response.data.message
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message

        };
    }
}

//get by user roles with pagination
/*const GetByRole = async (role, page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}user/get-by-role?role=${role}&page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        if (response.status === 200) {
            return {
                status: 200,
                users: response.data.users,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
} */

//get by user roles with pagination and status
const GetByRole = async (role, status, page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}user/get-by-role?role=${role}&status=${status}&page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        if (response.status === 200) {
            return {
                status: 200,
                users: response.data.users,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

const UpdateMemberPassword = async (id, newPassword, retypePassword) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("newPassword", newPassword);
        data.append("retypePassword", retypePassword);

        console.log("Data in service : " + data);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'user/member/update-password', data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                user: response.data.user
            };
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.message
        };
    }
}

const UpdateMember = async (id, name, mobile, email, image, dob, genderId, cityId, bloodGroupId, address, landmark, whatsapp, pincode, status) => {
    try {
        const FormData = require('form-data');
        let data = new FormData();
        data.append('id', id);
        data.append('name', name);
        data.append('mobile', mobile);
        data.append('email', email);
        data.append('image', image);
        data.append('dob', dob);
        data.append('genderId', genderId);
        data.append('cityId', cityId);
        data.append('bloodGroupId', bloodGroupId);
        data.append('address', address);
        data.append('landmark', landmark);
        data.append('whatsapp', whatsapp);
        data.append('pincode', pincode);
        data.append('status', status);

        console.log("Image in service : " + image);
        console.log("Data in service : " + data);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'user/member/update', data,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log(response);
        if (response.status === 201) {
            console.log("User updated successfully");
            return {
                status: 200,
                message: response.data.message,
                user: response.data.user
            };
        }
        else {
            return {
                status: 400,
                message: response.data.message
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message

        };
    }
}

const GetLatestMemberByRole = async (role, count) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}user/get-latest-member?role=${role}&count=${count}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        if (response.status === 200) {
            return {
                status: 200,
                users: response.data.users
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

const Update = async (id, name, mobile, email, image, dob, genderId, cityId, bloodGroupId, address, landmark, whatsapp, pincode) => {
    try {
        const FormData = require('form-data');
        let data = new FormData();
        data.append('id', id);
        data.append('name', name);
        data.append('mobile', mobile);
        data.append('email', email);
        data.append('image', image);
        data.append('dob', dob);
        data.append('genderId', genderId);
        data.append('cityId', cityId);
        data.append('bloodGroupId', bloodGroupId);
        data.append('address', address);
        data.append('landmark', landmark);
        data.append('whatsapp', whatsapp);
        data.append('pincode', pincode);

        console.log("Image in service : " + image);
        console.log("Data in service : " + data);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'user/update', data,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log(response);
        if (response.status === 201) {
            console.log("User updated successfully");
            return {
                status: 200,
                message: response.data.message,
                user: response.data.user
            };
        }
        else {
            return {
                status: 400,
                message: response.data.message
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

const UpdatePassword = async (id, oldPassword, newPassword, retypePassword) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("oldPassword", oldPassword);
        data.append("newPassword", newPassword);
        data.append("retypePassword", retypePassword);

        console.log("Data in service : " + data);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'user/update-password', data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        console.log(response.data);
        if (response.status === 200) {            
            return {
                status: 200,
                message: response.data.message,
            };
        }
    } catch (error) {
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

const ActivateEpin = async (userId,epinCode) => {
    try {
        const FormData = require('form-data');
        let data = new FormData();
        data.append('epinCode', epinCode);
        console.log("Epin in service : " + epinCode);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + `user/activate-epin?userId=${userId}`, data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        console.log("Activate epin response:", response );
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                user: response.data.user
            };
        } 
    } catch (error) {
        console.log(error);
        return {
            status: 400, 
            message: error.response.data.message
        };
    }
}

//update can create epin
const UpdateCanCreateEpin = async (userId, canCreateEpin) => {
    try {
        const FormData = require('form-data');
        let data = new FormData();
        data.append('canCreateEpin', canCreateEpin);
        console.log("Epin in service : " + canCreateEpin);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + `user/update-epin-creation-permission?id=${userId}`, data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                user: response.data.user
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}

//update can create blog
const UpdateCanCreateBlog = async (userId, canCreateBlog) => {
    try {
        const FormData = require('form-data');
        let data = new FormData();
        data.append('canCreateBlog', canCreateBlog);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + `user/update-blog-creation-permission?id=${userId}`, data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                user: response.data.user
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}

export { UserLogin, LoggedUserDetail, Add, GetAll, GetById, UpdatePassword, GetByRole, UpdateMemberPassword, UpdateMember, GetLatestMemberByRole, Update, ActivateEpin, UpdateCanCreateEpin, UpdateCanCreateBlog };